import React from 'react';
import { Pagination } from '../Pagination';
import { MediaPlayback } from '../../model/MediaPlayback';

const List = ( { items, page, itemsPerPage, totalItems, onPageChange }: Props) => {
  return (
    <div className="border border-1 rounded-2 p-3">
      <div className="row border-bottom text-gray-12 list-header">
        <div className="col-2 col-lg-3 fw-bold pb-3 pe-1"><small>MEDIA</small></div>
        <div className="col-2 col-lg-3 fw-bold pb-3 pe-1 ps-1"><small>CAMPAIGN</small></div>
        <div className="col-2 col-lg-3 fw-bold pb-3 pe-1 ps-1"><small>PLAYLIST</small></div>
        <div className="col fw-bold pb-3 pe-1 ps-1"><small>PLAYED</small></div>
        <div className="col fw-bold pb-3 pe-1 ps-1"><small>VIEWS</small></div>
        <div className="col fw-bold pb-3 pe-1 ps-1"><small>PARTIALLY</small></div>
        <div className="col fw-bold pb-3 pe-1 ps-1"><small>FULLY</small></div>
      </div>
      {
        items.map(item => <div key={`${item.mediaId}|${item.campaignId}|${item.playlistId}`} className="row border-bottom text-gray-11">
            <div className="col-2 col-lg-3 pt-3 pb-3 pe-1 text-truncate">{item.mediaName}</div>
            <div className="col-2 col-lg-3 pt-3 pb-3 pe-1 ps-1 text-truncate">{item.campaignName}</div>
            <div className="col-2 col-lg-3 pt-3 pb-3 pe-1 ps-1 text-truncate">{item.playlistName}</div>
            <div className="col pt-3 pb-3 pe-1 ps-1">{item.played}</div>
            <div className="col pt-3 pb-3 pe-1 ps-1">{item.fully + item.partially}</div>
            <div className="col pt-3 pb-3 pe-1 ps-1">{item.partially}</div>
            <div className="col pt-3 pb-3 ps-1">{item.fully}</div>
          </div>
        )
      }
      <div className="flex-grow-1 d-flex justify-content-end pe-2 mt-3">
        <Pagination page={page} itemsPerPage={itemsPerPage} totalItems={totalItems} onChange={onPageChange} />
      </div>
    </div>
  );
}

interface Props {
  items: MediaPlayback[],
  page: number,
  itemsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void
}

export { List };
